const variantSlider = document.querySelector('.js-variant-selector-alt-slider');

const btnSlideToRight = document.querySelector('.js-variant-selector-alt-right');
const btnSlideToLeft = document.querySelector('.js-variant-selector-alt-left');

if (variantSlider) {

    const distance = 100;

    if (btnSlideToRight) {
        btnSlideToRight.addEventListener('click', () => {
            variantSlider.scrollBy({
                left: distance,
                behavior: 'smooth'
            });
        })
    }
    if (btnSlideToLeft) {
        btnSlideToLeft.addEventListener('click', () => {
            variantSlider.scrollBy({
                left: -distance,
                behavior: 'smooth'
            });
        })
    }
    

    variantSlider.addEventListener('scroll', () => {
        if (variantSlider.scrollLeft === variantSlider.scrollLeftMax){
            if (btnSlideToRight) {
                btnSlideToRight.classList.remove('show');
            }
        } else if (variantSlider.scrollLeft === 0) {
            if (btnSlideToLeft) {
                btnSlideToLeft.classList.remove('show');
            }
            if (btnSlideToRight) {
                btnSlideToRight.classList.add('show');
            }
        } else if (variantSlider.scrollLeft > 0) {
            if (btnSlideToLeft) {
                btnSlideToLeft.classList.add('show');
            }
        }
    })

    window.addEventListener('resize', () => {
        if (variantSlider.scrollLeft === variantSlider.scrollLeftMax) {
            if (btnSlideToRight) {
                btnSlideToRight.classList.remove('show');
            }
        } else if (variantSlider.scrollLeft === 0) {
            if (btnSlideToLeft) {
                btnSlideToLeft.classList.remove('show');
            }
            if (btnSlideToRight) {
                btnSlideToRight.classList.add('show');
            }
        } else if (variantSlider.scrollLeft > 0) {
            if (btnSlideToLeft) {
                btnSlideToLeft.classList.add('show');
            }
        }
    })
}